import styled from "styled-components";

export const CollectionOverviewContainer = styled.div`
  display: flex;
  margin-top: 8rem;
  flex-direction: column;
`;
